// react
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import theme from "../../data/theme";
import shopApi from "../../api/shop";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";

export default function AccountPagePassword() {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errors, setErrors] = useState({});

    const userId = useSelector((state) => state.user.userConnected.user?.id);

    const handleChangePassword = async () => {
        const newErrors = {};

        if (newPassword.length < 6) {
            newErrors.newPassword = "Le nouveau mot de passe doit contenir au moins 6 caractères.";
        }

        if (newPassword !== confirmPassword) {
            newErrors.confirmPassword = "Les nouveaux mots de passe ne correspondent pas.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        try {
            shopApi.changeUserPassword(newPassword, currentPassword, userId).then((response) => {
                console.log(response, "response");
                
                setCurrentPassword("");
                setNewPassword("");
                setConfirmPassword("");
                setErrors({});
                if (response.response.status === 400) {
                    toast.error("L'ancien mot de passe est incorrect.", {
                        theme: "colored",
                        autoClose: 20000,
                    });
                }
            });
        } catch (error) {
            console.log(error, `error`);
        }
    };

    return (
        <div className="card">
            <Helmet>
                <title>{`Change Password — ${theme.name}`}</title>
            </Helmet>

            <div className="card-header">
                <h5><FormattedMessage id="Account.changePassword" defaultMessage="Change Password" /></h5>
            </div>
            <div className="card-divider" />
            <div className="card-body">
                <div className="row no-gutters">
                    <div className="col-12 col-lg-7 col-xl-6">
                        <div className="form-group">
                            <label htmlFor="password-current"><FormattedMessage id="Account.currentPassword" defaultMessage="Current Password" /></label>
                            <input
                                type="password"
                                className={`form-control ${errors.currentPassword ? "is-invalid" : ""}`}
                                id="password-current"
                             
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                            />
                            {errors.currentPassword && <div className="invalid-feedback">{errors.currentPassword}</div>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="password-new"><FormattedMessage id="Account.newPassword" defaultMessage="New Password" /></label>
                            <input
                                type="password"
                                className={`form-control ${errors.newPassword ? "is-invalid" : ""}`}
                                id="password-new"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                            {errors.newPassword && <div className="invalid-feedback">{errors.newPassword}</div>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="password-confirm"><FormattedMessage id="Account.confirmPassword" defaultMessage="Confirm Password" /></label>
                            <input
                                type="password"
                                className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
                                id="password-confirm"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                            {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
                        </div>

                        {errors.apiError && <div className="text-danger mb-3">{errors.apiError}</div>}

                        <div className="form-group mt-5 mb-0">
                            <button type="button" className="btn btn-primary" onClick={handleChangePassword}>
                                <FormattedMessage id="Account.changePassword" defaultMessage="Change Password" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
